<!-- Update 01/04/22 -->
<div class="grid table-demo">
  <div class="col-12">
    <div class="card mt-2">
      <h5>{{ title | translate }}</h5>

      <div class="p-fluid grid formgrid ml-3">
        <div class="field">
          <label>Seleccionar Rango de Fechas</label>
          <p-calendar
            #rangeDate
            [(ngModel)]="rangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            dataType="date"
            placeholder="{{ 'Rango de Fechas' | translate }}"
            [showButtonBar]="true"
            [readonlyInput]="true"
            [showIcon]="true"
            (onClearClick)="clearFilters()"
            (onSelect)="selectDateRange(rangeDate.value)"
          ></p-calendar>
        </div>
      </div>

      <div id="chart-sales-comparative">
        <!-- <dx-funnel
          id="funnel"
          [dataSource]="locationSalesTotalsData"
          argumentField="location_name"
          valueField="total1"
          palette="Soft Pastel"
        >
          <dxo-title [text]="headerText">
            <dxo-margin [bottom]="30"></dxo-margin>
          </dxo-title>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-tooltip [enabled]="true" format="fixedPoint"> </dxo-tooltip>
          <dxo-item>
            <dxo-border [visible]="true"> </dxo-border>
          </dxo-item>
          <dxo-label
            [visible]="true"
            position="inside"
            backgroundColor="none"
            [customizeText]="customizeText"
          ></dxo-label>
        </dx-funnel> -->
        <!-- <dx-chart
              palette="Harmony Light"
              [dataSource]="locationSalesTotalsData"
              (onSeriesClick)="onSeriesClick($event)"
            >
              <dxi-series
                valueField="total1"
                [name]="'Ventas Bodega'"
              ></dxi-series>
              <dxi-series
                valueField="total2"
                [name]="'Ventas Showroom'"
              ></dxi-series>
              <dxo-common-series-settings
                #commonSeries
                argumentField="location_name"
                type="fullstackedarea"
              >
              </dxo-common-series-settings>
              <dxo-adaptive-layout [width]="300"></dxo-adaptive-layout>
              <dxo-margin [bottom]="20"></dxo-margin>
              <dxo-argument-axis
                [valueMarginsEnabled]="false"
              ></dxo-argument-axis>
              <dxo-export [enabled]="true"></dxo-export>
              <dxo-tooltip
                [enabled]="true"
                format="fixedPoint"
                [customizeTooltip]="customizeTooltip"
              ></dxo-tooltip>
              <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
              </dxo-legend>
            </dx-chart> -->
      </div>
    </div>
  </div>
</div>
